export default __webpack_public_path__ + "static/media/gif.c51c77fc.webp";